import {SettingsCard} from "./SettingsCard";
import {Button, message, Typography} from "antd";
import {downloadUserAgreement} from "../../../features/userSettings/actions";
import {useAppDispatch, useAppSelector, useTranslate} from "../../../hooks";
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import styles from './DocumentsCard.module.scss';

export const DocumentsCard = () => {
	const t = useTranslate([
		'firstNameText',
		'lastNameText',
		'personalInformationText',
		'companyInformationText2',
		'downloadText',
		'userAgreementText',
		'emailAddressText',
		'agreementNotFoundText',
		'RESIDENCE_PERMIT',
		'PASSPORT',
		'DRIVERS_LICENSE',
		'ID_CARD',
		'DOCUMENT_NONE',
		'documents',
		'identityDocument'
	]);
	const settings = useAppSelector((state) => state.userSettings.entity);
	const dispatch = useAppDispatch();
	const onSaveAgreement = () => {
		dispatch(
			downloadUserAgreement({
				agreement: settings.agreement,
				fileName: `${t.userAgreementText}.pdf`,
			}),
		)
			.unwrap()
			.catch(() => {
				message.warn(t.agreementNotFoundText);
			});
	};
	return (
		<SettingsCard title={t.documents}>
			<div className={styles.list}>
				<div className={styles.item}>
					<Typography.Text>{t.userAgreementText}</Typography.Text>
					<Button type="link" className={styles.download} onClick={onSaveAgreement}>
						<DownloadIcon className={styles.downloadIcon} />
						{t.downloadText}
					</Button>
				</div>
				<div className={styles.item}>
					<Typography.Text>{t.identityDocument}</Typography.Text>
					<span>{t[settings?.veriff_document_type || 'DOCUMENT_NONE']}</span>
				</div>
			</div>
		</SettingsCard>
	)
}

export default DocumentsCard;
